var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"buttons buttons--add",attrs:{"disabled":_vm.disabled,"data-cy":"save"},on:{"click":function($event){_vm.action == _vm.save()}}},[_vm._v(" "+_vm._s(_vm.$t('global:save'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }